import { useCallback, useReducer } from "react";

type PartialKey<T> = { [K in keyof T]: { key: K; value: T[K] } }[keyof T];

export function useFilterState<T extends Record<string, unknown>>(initial: T) {
  const [filters, dispatch] = useReducer(
    (state: T, action: PartialKey<T> | Partial<T>) => {
      if ("key" in action && "value" in action) {
        return { ...state, [action.key as string]: action.value } as T;
      }
      return { ...state, ...action } as T;
    },
    initial,
  );

  const setFilter = useCallback(<K extends keyof T>(key: K, value: T[K]) => {
    dispatch({ key, value } as PartialKey<T>);
  }, []);

  const mergeFilters = useCallback((patch: Partial<T>) => {
    dispatch(patch);
  }, []);

  return { filters, setFilter, mergeFilters };
}
